/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseBulkTaxCalculationService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseBulkTaxCalculationCalculateBulkTaxes(
requestBody?: Array<Wealthlane_AwardService_Dtos_Release_ReleaseItemIdsDto>,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-bulk-tax-calculation/calculate-bulk-taxes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
